import axios from "axios";
import store from "@/stores";

const setAuthentication = (context, payload) => {
  context.commit("setAuthentication", payload);
};

const unsetAuthentication = (context) => {
  context.commit("setAuthentication", null);
};

const setDecodedAuthentication = (context, payload) => {
  context.commit("setDecodedAuthentication", payload);
};

const unsetDecodedAuthentication = (context) => {
  context.commit("setDecodedAuthentication", null);
};

const setUserRole = (context, payload) => {
  context.commit("setUserRole", payload);
};

const unsetUserRole = (context) => {
  context.commit("setUserRole", null);
};

const setOrganisations = (context, payload) => {
  context.commit("setOrganisations", payload);
};

const unsetOrganisations = (context) => {
  context.commit("setOrganisations", null);
};

const setSelectedOrganisation = (context, payload) => {
  context.commit("setSelectedOrganisation", payload);
};

const unsetSelectedOrganisation = (context) => {
  context.commit("setSelectedOrganisation", null);
};

const initializeLogSources = async (context, organisation_id) => {
  const headers = {
    Authorization: `Bearer ${store.state.authentication}`,
  };

  await axios
    .get(`log-sources/${organisation_id}`, { headers })
    .then((response) => {
      if (
        typeof response.data.success !== "undefined" &&
        response.data.success === true
      ) {
        setLogSources(
          context,
          response.data.log_sources !== null ? response.data.log_sources : [],
        );
      }
    })
    .catch(() => {});
};

const setLogSources = (context, payload) => {
  context.commit("setLogSources", payload);
};

const unsetLogSources = (context) => {
  context.commit("setLogSources", null);
};

const initializeGrokPatterns = async (context) => {
  context.commit("setGrokPatterns", null);

  await axios
    .get("grok-patterns", {
      headers: {
        Authorization: `Bearer ${store.state.authentication}`,
      },
    })
    .then((response) => {
      if (response.data.grok_patterns !== null) {
        context.commit("setGrokPatterns", response.data.grok_patterns);
      }
    })
    .catch(() => {});
};

const unsetGrokPatterns = (context) => {
  context.commit("setGrokPatterns", null);
};

const setProducts = (context, payload) => {
  context.commit("setProducts", payload);
};

const unsetProducts = (context) => {
  context.commit("setProducts", null);
};

const setTokenResetTimestamp = (context, payload) => {
  context.commit("setTokenResetTimestamp", payload);
};

const unsetTokenResetTimestamp = (context) => {
  context.commit("setTokenResetTimestamp", null);
};

const toggleMenuCollapsed = (context) => {
  let collapsed = !context.state.menuCollapsed;
  context.commit("setMenuCollapsed", collapsed);
};

const unsetMenuCollapsed = (context) => {
  context.commit("setMenuCollapsed", false);
};

const toggleListCollapsed = (context) => {
  let collapsed = !context.state.listCollapsed;
  context.commit("setListCollapsed", collapsed);
};

const unsetListCollapsed = (context) => {
  context.commit("setListCollapsed", false);
};

export default {
  setAuthentication,
  unsetAuthentication,

  setDecodedAuthentication,
  unsetDecodedAuthentication,

  setUserRole,
  unsetUserRole,

  setOrganisations,
  unsetOrganisations,

  setSelectedOrganisation,
  unsetSelectedOrganisation,

  initializeLogSources,
  setLogSources,
  unsetLogSources,

  initializeGrokPatterns,
  unsetGrokPatterns,

  setProducts,
  unsetProducts,

  setTokenResetTimestamp,
  unsetTokenResetTimestamp,

  toggleMenuCollapsed,
  unsetMenuCollapsed,

  toggleListCollapsed,
  unsetListCollapsed,
};
